import { createContext } from 'react';
export var CleatTriageContext = createContext({
    setTriageNotes: function () { }
});
export default CleatTriageContext;
